var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarrot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 16,
  fill: "none",
  viewBox: "0 0 11 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00ACD8",
  d: "M9.5 16a1.58 1.58 0 0 1-1-.36l-8-6.87a1.3 1.3 0 0 1-.47-1c.013-.393.2-.76.51-1l8-6.4a1.58 1.58 0 0 1 2.09.14 1.29 1.29 0 0 1-.15 1.92L3.7 7.8l6.81 5.83a1.29 1.29 0 0 1 .07 1.93A1.5 1.5 0 0 1 9.5 16"
})));
export default SvgCarrot;